import { render, staticRenderFns } from "./host-module.vue?vue&type=template&id=14fe039a&scoped=true"
import script from "./host-module.vue?vue&type=script&lang=js"
export * from "./host-module.vue?vue&type=script&lang=js"
import style0 from "./host-module.vue?vue&type=style&index=0&id=14fe039a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fe039a",
  null
  
)

export default component.exports